import { render, staticRenderFns } from "./chargeCard-use-details.vue?vue&type=template&id=1beb90e2&scoped=true&"
import script from "./chargeCard-use-details.vue?vue&type=script&lang=js&"
export * from "./chargeCard-use-details.vue?vue&type=script&lang=js&"
import style0 from "./chargeCard-use-details.vue?vue&type=style&index=0&id=1beb90e2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1beb90e2",
  null
  
)

export default component.exports